// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Werkelijk factureerbaar',
    actual_cost: 'Werkelijke kosten',
    ActualBillableExpenses: 'Werkelijke factureerbare kosten',
    ActualBillableExpensesShort: 'Werkelijke factureerbare kosten',
    ActualBilledShort: 'Werkelijk gefactureerd',
    ActualBillingShort: 'Werkelijk factureerbaar',
    ActualBudgetProfitability: 'Werkelijke budgetprestatie',
    ActualCost: 'Werkelijke kosten',
    ActualCostQtip: 'Werkelijke kosten = Werkelijke loonkosten + Werkelijke kosten',
    ActualExpenses: 'Werkelijke kosten',
    ActualExpensesListTitle: 'Werkelijk',
    ActualExpensesShort: 'Werkelijke kosten',
    ActualHours: 'Werkelijke uren',
    ActualLaborBilling: 'Werkelijke factureerbare arbeid',
    ActualLaborBillingShort: 'Werkelijke factureerbare arbeid',
    ActualLaborCost: 'Werkelijke loonkosten',
    ActualLaborCostShort: 'Werkelijke loonkosten',
    add_activities_flat_fees: 'Activiteiten met vaste tarieven toevoegen',
    add_as_actual_expense: 'Toevoegen als werkelijke kosten',
    add_planned_billable_expenses: 'Geplande factureerbare kosten toevoegen',
    add_received_payment: 'Ontvangen betaling toevoegen',
    add_scheduled_payment: 'Geplande betaling toevoegen',
    AddActivitiesBudgets: 'Activiteitenbudgetten toevoegen',
    AddBudgetLabel: 'Voeg een budget toe voor dit project',
    AddPlannedExpenses: 'Geplande kosten toevoegen',
    Amount: 'Bedrag',
    ApproveTooltip: 'Plant uitgaven overzetten naar werkelijke uitgaven',
    back_to_metrics: 'Terug naar statistieken',
    batch_actual_text: 'Toevoegen als werkelijke kosten',
    batch_billed_text: 'Markeren als gefactureerd',
    batch_operation_failed_description: 'De bewerking kon niet worden voltooid voor deze kosten. Dit kan te wijten zijn aan het feit dat ze zijn verwijderd of dat er geen toestemming is om bewerkingen ermee uit te voeren. Raadpleeg uw {brandName} beheerder voor mogelijke oorzaken.',
    batch_operations_failed_description: 'De bewerking kon niet worden voltooid voor {0} van de {1} kosten. Dit kan te wijten zijn aan het feit dat ze zijn verwijderd of dat er geen toestemming is om bewerkingen ermee uit te voeren. Raadpleeg uw {brandName} beheerder voor mogelijke oorzaken.',
    Billable: 'Factureerbaar',
    Billed: 'Gefactureerd',
    BilledPercentQtip: 'Gefactureerd = (Gefactureerde arbeid + Gefactureerde kosten) / EAC factureerbaar * 100%',
    BilledVsActualCost: 'Gefactureerd versus werkelijke kosten',
    Billing: 'Factureerbaar',
    Billing_Info_Title: 'Factureerinfo',
    BillingHelp: 'In het factureerbare gedeelte kunt u het juiste type facturering voor uw project kiezen en een tarief instellen, zoals per uur, of een vast bedrag voor een vast tarief project.',
    BillingSettings: 'Facturatie-instellingen',
    BillingSettingsTitle: 'Facturering',
    BillingType: 'Factureringstype',
    BillingTypeLabel: 'Berekenen op basis van ',
    BillingUtilization: 'Gebruik van upfront facturatie',
    BudgetedCost: 'Totaal projectbudget',
    BudgetHelp: 'In dit gedeelte kunt u het totale budget van het project bekijken, samengesteld uit dat van al zijn activiteiten, en een projectbudget instellen.',
    CancelTooltip: 'Annuleren',
    chart_actual_billing: 'Werkelijk factureerbaar',
    chart_actual_cost: 'Werkelijke kosten',
    chart_billable_expenses: 'Factureerbare kosten',
    chart_billed: 'Gefactureerd',
    chart_billed_expenses: 'Gefactureerde kosten',
    chart_eac_billing: 'EAC factureerbaar',
    chart_expenses: 'Kosten',
    chart_non_billable_expenses: 'Niet-factureerbare kosten',
    chart_payments: 'Ontvangen betalingen',
    chart_scheduled_payments: 'Geplande betalingen',
    ContingencyPadding: 'Contingency',
    Cost: 'Totale kosten',
    CPI: 'CPI',
    CurrencyLabel: 'Valuta',
    CustomerHourlyRateLabel: 'Uurtarief klant',
    Date: 'Datum',
    delete_the_expense_title: 'De kosten verwijderen',
    delete_the_payment_title: 'De betaling verwijderen',
    DeletePaymentConfirmation: 'Weet u zeker dat u deze record wilt verwijderen?',
    DeleteTooltip: 'Verwijderen',
    Description: 'Beschrijving',
    DetailedReportTitleTemplate: 'Gedetailleerd rapport voor {0}',
    EAC: 'Schatting bij voltooiing',
    eac_billing: 'Schatting bij voltooiing (EAC) factureerbaar',
    eac_cost: 'Schatting bij voltooiing (EAC) kosten',
    EACBilling: 'EAC factureerbaar',
    EACBillingLong: 'Schatting bij voltooiing (EAC) factureerbaar',
    EACBillingQtip: 'Schatting bij voltooiing (EAC) factureerbaar = Werkelijk factureerbaar + ETC factureerbaar',
    EACBillingQtipInfo: 'Geschat totaal factureerbaar bedrag inclusief factureerbare arbeid en factureerbare kosten (Werkelijk + Schatting tot voltooiing (ETC))',
    EACCost: 'Schatting bij voltooiing (EAC) kosten',
    EACCost_short: 'EAC kosten',
    EACCostQtip: 'Schatting bij voltooiing (EAC) kosten = Werkelijke kosten + ETC kosten',
    EnteredBy: 'Ingevoerd door',
    EstimatedBudgetProfitability: 'Geschatte budgetrendabiliteit',
    EstimatedCostVariance: 'Geschatte kostenafwijking',
    EstimatedExpenses: 'Geschatte kosten',
    EstimatedHours: 'Geschatte uren',
    EstimatedProfit: 'Verwachte winst',
    EstimatedProfitPercentQtip: 'Verwachte winst (%) = (EAC factureerbaar - EAC kosten) / EAC factureerbaar * 100%',
    EstimatedProfitQtip: 'Verwachte winst = EAC factureerbaar - EAC kosten',
    etc_billing: 'Schatting tot voltooiing (ETC) factureerbaar',
    etc_cost: 'Schatting tot voltooiing (ETC) kosten',
    ETCBillableExpenses: 'ETC factureerbare kosten',
    ETCBillableExpensesShort: 'ETC factureerbare kosten',
    ETCBilling: 'ETC factureerbaar',
    ETCBillingShort: 'ETC factureerbaar',
    ETCCost: 'ETC kosten',
    ETCCostShort: 'ETC kosten',
    ETCCosttQtip: 'Schatting tot voltooiing (ETC) kosten = ETC loonkosten + ETC kosten',
    ETCExpenses: 'ETC kosten',
    ETCExpensesShort: 'ETC kosten',
    ETCLaborBilling: 'ETC factureerbare arbeid',
    ETCLaborBillingShort: 'ETC factureerbare arbeid',
    ETCLaborCost: 'ETC loonkosten',
    ETCLaborCostShort: 'ETC loonkosten',
    ExpectedRevenue: 'Verwachte inkomsten',
    expenses: '1#{0} kosten',
    expenses_updated_successfully_plural: '1#Uitgaven zijn succesvol bijgewerkt.#{0} uitgaven zijn succesvol bijgewerkt.',
    FeeAmount: 'Kostenbedrag',
    FlatFee: 'Vaste kosten',
    GeneralInfo: 'Algemene informatie',
    HourlyRate: 'Uurtarief',
    InternalBudget: 'Budget',
    InternalEstimatedCost: 'Geschatte kosten',
    LaborBilling: 'Factureerbare arbeid',
    LaborCost: 'Arbeidskosten',
    legend_actual: 'Werkelijk',
    legend_estimated_at_completion: 'Schatting bij voltooiing',
    log_actual_expense: 'Werkelijke uitgave registreren',
    log_expenses: 'Uitgaven registreren',
    log_payments: 'Betalingen registreren',
    log_planned_expense: 'Geplande uitgave registreren',
    money_for_date_label: '{0} voor {1}?',
    no_targets: 'Geen doelen om weer te geven',
    NoActualExpenses: 'Er zijn geen uitgaven.',
    None: 'Geen',
    NoneCurrency: 'Kies valuta',
    NoPayments: 'Er zijn geen betalingen.',
    NoPlannedExpenses: 'Er zijn geen geplande uitgaven.',
    NotBillable: 'Niet factureerbaar',
    NotBillableLabel: 'Niet factureerbaar',
    NotBilled: 'Niet gefactureerd',
    OpenRateCard: 'Open tariefkaart',
    OutstandingPaymentBalance: 'Uitstaand betalingsaldo',
    PaymentDescriptionWatermark: 'Beschrijving...',
    PaymentReceived: 'Betaling ontvangen',
    payments_total: '1#{0} betaling#{0} betalingen',
    PaymentsOfSchedPayments: 'Betalingen van geplande betalingen',
    PercentageBilled: 'Percentage gefactureerd',
    PercentageProjectBilled: 'Percentage gefactureerd',
    Percentages: 'Percentage',
    PlannedExpenses: 'Geplande uitgaven',
    PlannedExpensesListTitle: 'Gepland',
    ppFormat: '{0}pp',
    Profit: 'Winst',
    ProfitQtip: 'Winst = Werkelijke factureerbare arbeid - Werkelijke kosten',
    Project_no_rateCard_for_rateCard_billingType: 'U moet een tariefkaart opgeven als projectfacturering is gebaseerd op tariefkaart.',
    ProjectActivityName: 'Project / activiteit naam',
    ProjectBilling: 'Projectfacturering',
    ProjectBillingIsBasedOn: 'Projectfacturering is gebaseerd op',
    ProjectBillingUtilization: 'Facturatiegebruik',
    ProjectBudget: 'Arbeidsbudget',
    ProjectCost: 'Project interne kosten',
    ProjectCostVariance: 'Project kostenvariatie',
    ProjectEarnedValue: 'Project verdiende waarde',
    ProjectEarnedValueInfo: 'Stelt projectgezondheid voor',
    ProjectExpectedRevenue: 'Verwachte omzet van het project',
    ProjectFixedCostLabel: 'Project vaste kosten',
    ProjectHourlyRateLabel: 'Project uurtarief',
    ProjectPayments: 'Projectbetalingen',
    ProjectPlannedExpenses: 'Geplande projectuitgaven',
    ProjectPlannedExpensesInfo: 'Uitgaven gepland voor een specifiek project en geplande uitgaven samengevoegd uit de activiteiten',
    ProjectProfit: 'Projectwinst',
    ProjectProfitability: 'Projectwinstgevendheid',
    ProjectProfitabilityInfo: 'Stelt het percentage van de gecreëerde waarde per project voor',
    ProjectTimeUsage: 'Projecttijdsgebruik',
    ProjectTimeUsageInfo: 'Geeft weer hoeveel van het gebudgetteerde tijdsgebruik we hebben gebruikt, werkelijk als een percentage van geschatte uren',
    ProjectWorkInProgress: 'Projectwerk in uitvoering',
    PymentsVsActualCost: 'Betalingen vs. werkelijke kosten',
    RateCardLabel: 'Tariefkaart',
    Receipt: 'Ontvangstbewijs',
    Received: 'Ontvangen',
    ReceivedPaymentsListTitle: 'Ontvangen',
    RemainingInternalBudget: 'Resterend budget',
    RemainingInternalBudgetQtip: 'Resterend budget = Budget - Werkelijke kosten',
    RemainingInternalBudgetQtipForProject: 'Resterend budget = Totaal budget - Werkelijke kosten',
    ResourceHourlyRateLabel: 'Uurtarief van de resource',
    Revenue: 'Inkomsten',
    Scheduled: 'Gepland',
    ScheduledPaymentsListTitle: 'Gepland',
    set_targets: 'Stel doelen in met behulp van de',
    Settings: 'Instellingen',
    ShowAll: 'ALLES WEERGEVEN',
    ShowBreakdown: 'Toon afbraak',
    ShowFull: 'TOON VOLLEDIG',
    SPI: 'SPI',
    tab_Actual: 'Werkelijke uitgaven',
    tab_expenses: 'Uitgaven',
    tab_overview: 'Overzicht',
    tab_payments: 'Betalingen',
    tab_Planned: 'Geplande uitgaven',
    tab_Received: 'Ontvangen betalingen',
    tab_Scheduled: 'Geplande betalingen',
    tab_targets: 'Doelen',
    TargetBudget: 'Totaal budget',
    TargetLaborRevenue: 'Doel arbeidsopbrengst',
    TargetProfit: 'Doelwinst',
    TargetRevenue: 'Doelinkomsten',
    Targets: 'Doelen',
    targets_tab: 'Doelen tabblad',
    TargetsEACBilling: 'EAC factureerbaar',
    TaskRateLabel: 'Activiteitentarief',
    TimeAndMaterial: 'Tijd en materiaal',
    TimeUsage: 'Tijdgebruik',
    TitleText: 'Financieel',
    total_billable: 'Totaal factureerbaar',
    TotalBilled: 'Totaal gefactureerd',
    TotalProjectBudget: 'Totaal projectbudget',
    TotalProjectPayments: 'Totaal projectbetalingen',
    TotalProjectPaymentsInfo: 'Samenvatting van alle betalingen gedaan door alle klanten',
    TotalTargetRevenue: 'Totale doelinkomsten',
    TrackProfitAs: 'Volg winst als',
    Validation_DateMandatory: 'Datum is een verplicht veld.',
    Validation_InvalidAmount: 'Bedrag moet positief zijn.',
    Validation_InvalidDate: 'Datum moet in \'{0}\' formaat zijn.',
    Validation_Range: 'Waarde valt niet binnen de verwachte range.',
    Variance: 'Variance',
    warning_currency: 'Valuta wordt overgenomen van de gekozen tariefkaart',
    WorkInProgress: 'Werk in uitvoering',
};
